export const TABLE_ROW_EXPANDING_DURATION_MS = 300;
export const TABLE_CELL_FULL_ROW_COL_SPAN = 1000;
